// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1zfhP","footer":"ModalCreateQualiphyProcedure_footer__1Qqks","additionData":"ModalCreateQualiphyProcedure_additionData__3LBjC"};